import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import RequestsPanel, { FILTERS } from './RequestsPanel';
import './InboxPage.css';

export const KINDS = ['contact', 'songs'];

export { FILTERS };

// DJB-264: /inbox itself opens Contact Requests; the pre-DJB-264 ?tab=songs
// deep link lands on its own route
export const InboxIndexRedirect = () => {
  const location = useLocation();
  const tab = new URLSearchParams(location.search).get('tab');
  return <Navigate to={`/inbox/${KINDS.includes(tab) ? tab : 'contact'}`} replace />;
};

// One inbox page per request kind (Contact Requests at /inbox/contact, Song
// Requests at /inbox/songs). The filter + list is the RequestsPanel, which
// the Upload page mounts as well (DJB-269); only the inbox pages show its
// segmented Contact Requests | Song Requests switch (DJB-279).
const InboxPage = ({ kind = 'contact' }) => (
  <div className="inbox-page">
    <RequestsPanel kind={kind} showKindSwitch />
  </div>
);

export default InboxPage;
